// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader___3uM1d","fullScreen":"fullScreen___23-dd","wrapper":"wrapper___1_9ss","inner":"inner___25tZ5","text":"text___3iwor","hidden":"hidden___3F57d","spinner":"spinner___ESwF7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.less
// module id = Ru/P
// module chunks = 18